import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

//const Login = () => import('@/views/Login') to allow cloak to work, so we don't see a flash of the sidebar when we refresh the login page, this isn't lazy loaded
import Login from '@/views/Login.vue';
const Subscription = () => import('@/views/Subscription')
const Help = () => import('@/views/Help')
const Install = () => import('@/views/Install')
const Uninstall = () => import('@/views/Uninstall')
const Home = () => import('@/views/Home')
const HomeBase = () => import('@/views/HomeBase')
const Camera = () => import('@/views/Camera')
const PleaseLogin = () => import('@/views/PleaseLogin')
const PleaseUpgrade = () => import('@/views/PleaseUpgrade')

Vue.use(Router)

let router = new Router({
  //https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history', //won't use hashmode URLs, so requires we redirect 404 errors to index.html
  //https://vueschool.io/articles/vuejs-tutorials/vue-js-router-performance/
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
        path: '/help',
        name: 'Help',
        component: Help
    },
    {
      path: '/please_login',
      name: 'PleaseLogin',
      component: PleaseLogin
    },
    {
      path: '/please_upgrade',
      name: 'PleaseUpgrade',
      component: PleaseUpgrade
    },
    {
      path: '/install',
      name: 'Install',
      component: Install,
      meta: { 
        auth: true
      }
    },
    {
      path: '/uninstall',
      name: 'Uninstall',
      component: Uninstall
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription,
      meta: {
        auth: true
      }
    },
    {
      path: '/camera',
      name: 'Camera',
      component: Camera,
      meta: {
        auth: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: { 
        auth: true      
      }
    },
    {
      path: '/home_base',
      name: 'HomeBase',
      component: HomeBase,
      meta: { 
        auth: true,
        showNavigation: true
      }
    },
    {
      path: '/',
      redirect: '/home'
    },
  ]
})

router.beforeEach((to, from, next) => 
{
  if (to.matched.some(record => record.meta.auth)) 
  {
    firebase.auth().onAuthStateChanged(user => {
      if (user) 
      {
        next()
      } 
      else 
      {
        sessionStorage.setItem('redirect_to_path', window.location.pathname);//will be retrieved in Home.vue to redirect the user
        sessionStorage.setItem('search_query', window.location.search);//will be retrieved by Login.vue to get the parent tab ID
        next({
          path: "/login"
        })
      }
    })
  } 
  else 
  {
    next()
  }
})

export default router
